import React, { useEffect, useState } from "react";
import propTypes from "prop-types";
import { api, IAssetMovements, AssetMovement, AssetType } from "../../../logic/api";
import styles from "../styles";
import MovementListItem from "../../../components/lists/listItems/MovementListItem/MovementListItem";
import { PagedDataView } from "../../../components/lists/PagedDataView/PagedDataView";
import usePaths from "../../../utility/paths";
import AssetMovementRow from "./condensedLayout/assetMovement/AssetMovementRow";
import HeaderRow from "./condensedLayout/HeaderRow";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useReleaseManagement, ReleaseFlag } from "../../../utility/feature-management";

const AssetMovementsAtLocation: React.FunctionComponent<{
  path: string;
  type: AssetType;
  isCondensedView?: boolean;
}> = (props) => {
  const paths = usePaths();
  const history = useHistory();
  const { t } = useTranslation();
  const [params, setParams] = useState<IAssetMovements>({
    path: props.path,
    type: props.type
  });
  const isOpenLinksInNewTab = useReleaseManagement(ReleaseFlag.releaseOpenLinksInNewTabs);

  useEffect(() => {
    if (props.path != params.path) {
      setParams({
        ...params, path: props.path, type: props.type
      });
    }
  }, [props.path, props.type]);

  const handleGoToBooking = (bookingId: number) => {
    if (isOpenLinksInNewTab) {
      window.open(paths.booking(bookingId), "_blank");
    } else {
      history.push(paths.booking(bookingId));
    }
  }

  const columnHeaders = [t("locations.direction"), t("booking.labels.ref"), "", t("locations.vehicleReg"), "", t("booking.cards.vehicle"), t("booking.labels.vehicleLastMovementBy"), t("booking.labels.vehicleLastMovement"), ""];

  columnHeaders[2] = (props.type === AssetType.vehicle) ? t("booking.labels.vehicleLocation") : t("booking.labels.keyLocation");

  return <div>
    {props.isCondensedView ?
      <PagedDataView<IAssetMovements, AssetMovement>
        apiHook={api.hooks.assetMovement.getMovementsAtPath}
        parameters={params}
        header={() => <HeaderRow columnHeaders={columnHeaders} />}
        isTable
        animate={false}
        renderItem={(item, index) => {
          return <AssetMovementRow assetMovement={item} movementCategory={props.type} rowIndex={index} onClick={() => handleGoToBooking(item.booking.id)} />
        }}
      >
        <div style={styles.noData}>
          {t("input.validations.noMovements")}
        </div>
      </PagedDataView>
      :
      (
        <PagedDataView<IAssetMovements, AssetMovement>
          apiHook={api.hooks.assetMovement.getMovementsAtPath}
          parameters={params}
          animate={false}
          renderItem={(item) => {
            return <MovementListItem item={item} onClick={() => handleGoToBooking(item.booking.id)} />
          }}
        ><div style={styles.noData}>
            {t("input.validations.noMovements")}
          </div>
        </PagedDataView>
      )
    }
  </div>
};

AssetMovementsAtLocation.propTypes = {
  path: propTypes.string.isRequired,
  type: propTypes.any.isRequired
}

export default AssetMovementsAtLocation;
